/**
 * For all below collections we need to make sure that the usage of collection is not modifying the original one, so we are applying slice(0) on collection, and that clones it, removing reference to original collection
 */

export const statisticsScales = () => {
  const collection = [
    {
      handle: 'day',
      name: 'Day'
    },
    {
      handle: 'week',
      name: 'Week'
    },
    {
      handle: 'month',
      name: 'Month'
    },
  ]

  return collection.slice(0)
}

export const areaCategories = () => {
  const collection = [
    {
      id: 1,
      name: 'Luleå'
    },
    {
      id: 2,
      name: 'Sundsvall'
    },
    {
      id: 3,
      name: 'Stockholm'
    },
    {
      id: 4,
      name: 'Malmö'
    },
  ]

  return collection.slice(0)
}

export const contractTypes = () => {
  const collection = [
    {
      handle: 1,
      name: 'Fixed price 6 months'
    },
    {
      handle: 2,
      name: 'Fixed price 1 year'
    },
    {
      handle: 4,
      name: 'Fixed price 2 years'
    },
    {
      handle: 5,
      name: 'Fixed price 3 years'
    },
    {
      handle: 6,
      name: 'Fixed price 4 years'
    },
    {
      handle: 7,
      name: 'Fixed price 5 years'
    },
    {
      handle: 9,
      name: 'Floating 1 year'
    },
    {
      handle: 10,
      name: 'Floating price ongoing'
    },
    {
      handle: 13,
      name: 'Mixed contract 1 year'
    }
  ]

  return collection.slice(0)
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/Data/GeneralData.js